import { registerBlockType } from '@wordpress/blocks';
import { InnerBlocks } from '@wordpress/block-editor';
import './style.scss';
import Edit from './edit';
import metadata from './block.json';

// Mouchard 1 : On vérifie que le script se lance
console.log('🔥 1. Script JS chargé. Tentative enregistrement de :', metadata.name);

try {
    registerBlockType( metadata.name, {
        edit: Edit,
        // INDISPENSABLE pour les blocs avec InnerBlocks :
        // Même avec render.php, il faut sauvegarder la structure des blocs enfants
        save: () => {
            return <InnerBlocks.Content />;
        },
    } );
    // Mouchard 2 : Si on arrive ici, c'est gagné
    console.log('✅ 2. Enregistrement JS réussi pour :', metadata.name);
} catch (error) {
    // Mouchard 3 : Si ça plante, on saura pourquoi
    console.error('❌ 3. Erreur fatale enregistrement :', error);
}